import React from 'react';
import { NodeData } from '../../../pages/campaings/flows/types';

interface Props {
  data: NodeData;
}
const RedirectBody: React.FC<Props> = ({ data }) => {
  if (!data.redirect_agent) return <div>No se encontró información</div>;
  return (
    <>
      <p className="nowrap-lines-2 node-width-fit pe-2 mb-1">{data.redirect_agent.message.es}</p>
      <h6 className="node-title2 my-0 fs-8">Agentes</h6>
      <div className="d-flex flex-wrap gap-2 mw-350px mt-1">
        {data.redirect_agent.agents.map((a, i) => (
          <span className="badge bg-light-info text-dark fs-9" key={i}>
            {a}
          </span>
        ))}
      </div>
    </>
  );
};

export default React.memo(RedirectBody);
